import moment from "moment";

export const getAcademicYearValue = (year) => year?.label || year?.academic_year || "";
export const isDateInRange = (startInput, endInput, dateInput = null) => {
  if (!startInput || !endInput) return false;

  const toMoment = (input) => {
    if (!input) return null;
    if (moment.isMoment(input)) return input.clone().startOf("day");
    if (input instanceof Date) return moment(input).startOf("day");
    // Try flexible parsing first (handles ISO, human-readable, and DB formats)
    const m1 = moment(String(input));
    if (m1.isValid()) return m1.startOf("day");
    // Fallback: attempt YYYY-MM-DD slice parse
    const sliced = String(input).slice(0, 10);
    const m2 = moment(sliced, "YYYY-MM-DD", true);
    if (m2.isValid()) return m2.startOf("day");
    return null;
  };

  const start = toMoment(startInput);
  const end = toMoment(endInput);
  if (!start || !end) return false;

  const now = dateInput ? toMoment(dateInput) : moment().startOf("day");
  if (!now) return false;

  return now.isBetween(start, end, "day", "[]");
};

export const getActiveAcademicYear = (years) => {
  if (!Array.isArray(years) || years.length === 0) return "";
  const activeByDate = years.find((y) => isDateInRange(y?.start_date, y?.end_date));
  const activeByFlag = years.find(
    (y) => y.is_current === "Y" || y.is_active === "Y" || y.current === true,
  );

  if (activeByDate || activeByFlag) {
    return getAcademicYearValue(activeByDate || activeByFlag);
  }

  // Prefer the most recently started academic year that has already started (avoid choosing a future upcoming year)
  const toMoment = (input) => {
    if (!input) return null;
    if (moment.isMoment(input)) return input.clone().startOf("day");
    const m = moment(String(input));
    return m.isValid() ? m.startOf("day") : null;
  };

  const today = moment().startOf("day");
  const startedYears = years
    .map((y) => ({ row: y, start: toMoment(y?.start_date) }))
    .filter((r) => r.start && !r.start.isAfter(today, "day"));

  if (startedYears.length) {
    startedYears.sort((a, b) => b.start.valueOf() - a.start.valueOf());
    return getAcademicYearValue(startedYears[0].row);
  }

  return getAcademicYearValue(years[0]);
};

export const getActiveAcademicYearRow = (years) => {
  if (!Array.isArray(years) || years.length === 0) return null;
  // Reuse same logic as getActiveAcademicYear but return the full row object
  const activeByDate = years.find((y) => isDateInRange(y?.start_date, y?.end_date));
  const activeByFlag = years.find(
    (y) => y.is_current === "Y" || y.is_active === "Y" || y.current === true,
  );

  if (activeByDate || activeByFlag) return activeByDate || activeByFlag;

  const toMoment = (input) => {
    if (!input) return null;
    if (moment.isMoment(input)) return input.clone().startOf("day");
    const m = moment(String(input));
    return m.isValid() ? m.startOf("day") : null;
  };

  const today = moment().startOf("day");
  const startedYears = years
    .map((y) => ({ row: y, start: toMoment(y?.start_date) }))
    .filter((r) => r.start && !r.start.isAfter(today, "day"));

  if (startedYears.length) {
    startedYears.sort((a, b) => b.start.valueOf() - a.start.valueOf());
    return startedYears[0].row;
  }

  return years[0] || null;
};
